@if (inputData(); as inputData) {
  <h6 class="font-weight-bold">{{ 'screening.screening_overrides.suggestions.common_info.title' | translate }}</h6>
  <small>
    @if (inputData && inputData.birth_date) {
      <p class="m-0">
        <span class="text-muted me-2"
          >{{ 'screening.screening_overrides.suggestions.common_info.date_of_birth' | translate }}:
        </span>
        {{ inputData.birth_date | date }}
      </p>
    }
    @if (inputData && !inputData.birth_date && inputData.birth_year) {
      <p class="m-0">
        <span class="text-muted me-2"
          >{{ 'screening.screening_overrides.suggestions.common_info.year_of_birth' | translate }}:
        </span>
        {{ inputData.birth_year }}
      </p>
    }

    @if (inputData.street_address || inputData.postal_code || inputData.country_name || inputData.municipality_name) {
      <p class="m-0">
        <span class="text-muted me-2">{{
          'screening.screening_overrides.suggestions.common_info.address' | translate
        }}</span>
        {{ inputData.street_address }}, {{ inputData.postal_code }} {{ inputData.postal_place ?? '' | normalCase }}
      </p>
    }

    @if (flags$ | async; as flags) {
      @if (flags.length) {
        <p class="m-0">
          <span class="text-muted me-2">{{
            'screening.screening_overrides.suggestions.common_info.flags' | translate
          }}</span>
          @for (flag of flags; track flag.uuid) {
            <nk-person-flag-icon [personFlagEntity]="flag"></nk-person-flag-icon>
          }
        </p>
      }
    } @else {
      <nk-spinner></nk-spinner>
    }
    <!--Remove? Was nothing here
      <span class="text-muted me-2">{{ 'screening.screening_overrides.suggestions.common_info.national_identification_number' | translate }}</span>
      -
       -->
  </small>
} @else {
  <div class="text-muted">-</div>
}
<hr />
